/* fadeIn
========================================================= */
export function fadeIn($) {
  const $window = $(window);
  const $targets = $('.fadein');

  if (!$targets.length) {
    return;
  }

  function updateFadeIn() {
    const scrollTop = $window.scrollTop();
    const windowHeight = $window.height();

    $targets.each(function () {
      const $target = $(this);
      const targetTop = $target.offset().top;

      if (scrollTop > targetTop - windowHeight + 200) {
        $target.addClass('is-visible');
      }
    });
  }

  $window.on('scroll.fadeIn', updateFadeIn);

  updateFadeIn();
}
